<template>
  <div>
    <input ref="input" type="file" name="image" accept="image/*" @change="setImage" />

    <div class="content">
      <div class="actions">
        <b-btn variant="outline-info" size="sm" @click.prevent="showFileChooser">Upload Image</b-btn>
      </div>
      <div class="cropped-image">
        <img v-if="cropImg" :src="cropImg" alt="Cropped Image" />
        <div v-else class="crop-placeholder" />
      </div>
    </div>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Crop Image"
      size="lg"
      scrollable
      v-model="showImageCropModal"
    >
      <div class="cropper-area">
        <vue-cropper ref="cropper" :aspect-ratio="4 / 4" :src="imgSrc" />
      </div>
      <template v-slot:modal-footer>
        <b-btn size="sm" variant="outline-danger" @click.prevent="reset">Reset</b-btn>
        <b-btn size="sm" variant="outline-success" @click.prevent="cropImage">Crop</b-btn>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ProfileImageUpload",
  data() {
    return {
      showImageCropModal: false,
      imgSrc: "",
      cropImg: "",
      data: null,
    };
  },
  mounted() {
    this.setUserProfilePic();
  },
  methods: {
    setUserProfilePic() {
      let datail = JSON.parse(localStorage.getItem("userDetail"));
      let profilePhoto = datail.profile_img_url;
      if (profilePhoto) {
        this.cropImg = profilePhoto;
      } else {
        this.cropImg = "";
      }
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$store.state.profileImageBaseContent = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL();
      this.showImageCropModal = false;
    },
    reset() {
      this.$refs.cropper.reset();
      this.showImageCropModal = false;
    },
    setImage(e) {
      const file = e.target.files[0];

      if (file.type.indexOf("image/") === -1) {
        alert("Please select an image file");
        return;
      }

      if (typeof FileReader === "function") {
        const reader = new FileReader();

        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.$refs.cropper.replace(event.target.result);
        };

        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    showFileChooser() {
      this.showImageCropModal = true;
      this.$refs.input.click();
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
  },
};
</script>
<style>
input[type="file"] {
  display: none;
}

.content {
  display: flex;
  justify-content: space-between;
}

.cropper-area {
  width: 614px;
}

.actions {
  margin-top: 1rem;
}

.crop-placeholder {
  width: 100%;
  height: 200px;
  background: #ccc;
}

.cropped-image img {
  max-width: 50%;
}
</style>